import { AppBar, Button, Grid, Menu, Toolbar, Typography } from "@mui/material";
import { withStyles, WithStyles } from "@mui/styles";
import * as api from "api/Core";
import { DefaultListParameters } from "assets/appConfig";
import { GlobalClassKeys, TimelineStyleClasses } from "assets/jss/common-styles";
import AdvFilter, { advFilterAddCommand, AdvFilterCommand, AdvFilterComponent, AdvFilterPicker, AdvFilterResult } from "components/AdvFilter";
import { CmdAuthor, CmdAvailableEndDate, CmdAvailableStartDate, CmdCreateEndDate, CmdCreateStartDate, CmdKTBlocked, CmdKTImportance1, CmdKTImportance2, CmdKTImportance3, CmdKTLevel1, CmdKTLevel2, CmdKTLevel3, CmdWithImage, CmdWithVideo, CommandLabels } from "components/AdvFilter/CommonCommands";
import ButtonBack from "components/Buttons/ButtonBack";
import ButtonResetFilter from "components/Buttons/ButtonResetFilter";
import IconButtonBlocked from "components/Buttons/IconButtonBlocked";
import IconButtonOrderBy from "components/Buttons/IconButtonOrderby";
import { RequestIndicator } from "components/CallServer";
import { LoadingIndicator } from "components/CallServer/LoadingIndicator";
import RequestErrorDialog from "components/CallServer/RequestErrorDialog";
import { RequestErrorReport } from "components/CallServer/RequestErrorReport";
import CountFilter from "components/CountFilter";
import IconAdd from "components/Icons/IconAdd";
import { MuiFilterAdvancedContainer, MuiFilterAppBar, MuiFilterLine, MuiFilterToolbar } from "components/MuiExtras/Filter";
import MuiMessageBox from "components/MuiExtras/MessageBox/MuiMessageBox";
import MuiConfirmation from "components/MuiExtras/MuiConfirmation";
import MuiContainer from "components/MuiExtras/MuiContainer";
import MuiMenuItemChecked from "components/MuiExtras/MuiMenuItemChecked";
import MuiPagination from "components/MuiExtras/MuiPagination";
import MuiWarning from "components/MuiExtras/Typography/MuiWarning";
import { withSnackbar, WithSnackbar } from "components/SnackbarProvider/Snackbar";
import AppMessage from "components/Translations/AppMessage";
import { KnowledgeTestDifficultyLevel, KnowledgeTestImportance, SystemRoles } from "models/ApiEnums";
import { FeedAttachType, GetKnowledgeTestAdminListParams, KnowledgeTestAdminItemDto, KnowledgeTestAdminListFilter, KnowledgeTestAdminListOrderBy, PagedResult } from "models/ApiModels";
import { RequestLifeCycle } from "models/AppModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { RouteComponentProps, withRouter } from "react-router";
import Session from "services/Session";
import KnowledgeTestAdminCard from "views/KnowledgeTest/Components/KnowledgeTestAdminCard";
import CreateTest from "./CreateTest";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    advFilters: AdvFilterResult[];
    filter: KnowledgeTestAdminListFilter;
    orderBy: KnowledgeTestAdminListOrderBy;
    orderByMenuAnchorEl: any;

    list: PagedResult<KnowledgeTestAdminItemDto>;
    formCycle: RequestLifeCycle;
    offset: number;
    lastError: any;

    dialog: any;
    addByMenuAnchorEl: any;
}

interface IProps {
}

export interface KnowledgeTestAdminListParameters {
    topic: AutoCompleteDataModel;

    advFilters?: {
        author?: {
            id: string;
            name: string;
        },
        period?: {
            startDate: Date,
            endDate: Date;
        },
        diffcultyLevel?: KnowledgeTestDifficultyLevel;
    };
}

type Props = IProps & WithStyles<typeof TimelineStyleClasses> & RouteComponentProps<any, any, any> & WithTranslation & WithSnackbar;

/////////////////////////////////////////////////////////////////////////////////////////////////

export class KnowledgeTestAdminList extends React.Component<Props, IState> {

    private advFilterRef: AdvFilterComponent;
    private isFiltered: boolean = false;
    private selectedTopic: AutoCompleteDataModel = null;

    ///
    constructor(props: Props) {
        super(props);

        if (this.props.location.state && this.props.location.state.topic) {
            this.selectedTopic = this.props.location.state.topic as AutoCompleteDataModel;
        }

        this.state = {
            filter: this.resetFilter(),
            advFilters: this.parseHistoryAdvFilters(this.props.location.state as KnowledgeTestAdminListParameters),
            orderBy: KnowledgeTestAdminListOrderBy.DifficultyLevel,

            addByMenuAnchorEl: null,
            orderByMenuAnchorEl: null,

            list: { items: null, total: 0 },
            offset: 0,
            formCycle: RequestLifeCycle.None,
            lastError: null,
            dialog: null,
        };
    }


    ///
    private res(r: string, f: any = null) {
        return this.props.t("Views.KnowledgeTest.AdminList." + r, f);
    }

    ///
    private get commands(): AdvFilterCommand[] {
        const labels = CommandLabels();
        return [
            { keyword: CmdAuthor, displayName: labels[CmdAuthor], group: 1, picker: AdvFilterPicker.User, canRepeat: true },
            { keyword: CmdWithVideo, displayName: labels[CmdWithVideo], group: 1 },
            { keyword: CmdWithImage, displayName: labels[CmdWithImage], group: 1 },

            { keyword: CmdKTLevel1, displayName: labels[CmdKTLevel1], group: 2 },
            { keyword: CmdKTLevel2, displayName: labels[CmdKTLevel2], group: 2 },
            { keyword: CmdKTLevel3, displayName: labels[CmdKTLevel3], group: 2 },

            { keyword: CmdKTImportance1, displayName: labels[CmdKTImportance1], group: 3 },
            { keyword: CmdKTImportance2, displayName: labels[CmdKTImportance2], group: 3 },
            { keyword: CmdKTImportance3, displayName: labels[CmdKTImportance3], group: 3 },

            { keyword: CmdCreateStartDate, displayName: labels[CmdCreateStartDate], picker: AdvFilterPicker.Calendar, group: 4 },
            { keyword: CmdCreateEndDate, displayName: labels[CmdCreateEndDate], picker: AdvFilterPicker.Calendar, group: 4 },

            { keyword: CmdAvailableStartDate, displayName: labels[CmdAvailableStartDate], picker: AdvFilterPicker.Calendar, group: 5 },
            { keyword: CmdAvailableEndDate, displayName: labels[CmdAvailableEndDate], picker: AdvFilterPicker.Calendar, group: 5 },

            { keyword: CmdKTBlocked, displayName: labels[CmdKTBlocked], group: 6 },
        ];
    }


    ///
    private parseHistoryAdvFilters(p: KnowledgeTestAdminListParameters) {
        const commands = this.commands;
        var result: AdvFilterResult[] = [];

        if (p && p.advFilters) {

            const { advFilters } = p;

            if (advFilters.author && advFilters.author.id) {
                result = advFilterAddCommand(commands, result, CmdAuthor, advFilters.author.id, advFilters.author.name);
            }

            if (advFilters.period && advFilters.period.startDate != null) {
                result = advFilterAddCommand(commands, result, CmdCreateStartDate, advFilters.period.startDate);
            }

            if (advFilters.period && advFilters.period.endDate != null) {
                result = advFilterAddCommand(commands, result, CmdCreateEndDate, advFilters.period.endDate);
            }

            if (advFilters.diffcultyLevel === KnowledgeTestDifficultyLevel.Beginner) {
                result = advFilterAddCommand(commands, result, CmdKTLevel1, null, null);
            }
            else if (advFilters.diffcultyLevel === KnowledgeTestDifficultyLevel.Intermediate) {
                result = advFilterAddCommand(commands, result, CmdKTLevel2, null, null);
            }
            else if (advFilters.diffcultyLevel === KnowledgeTestDifficultyLevel.Advanced) {
                result = advFilterAddCommand(commands, result, CmdKTLevel3, null, null);
            }
        }

        return result;
    }

    ///
    private loadData(offset: number) {

        const { filter, orderBy } = this.state;

        const p: GetKnowledgeTestAdminListParams = {
            filter,
            orderBy,
            range: { offset: offset, take: DefaultListParameters.viewRecordsByPage }
        };

        this.setState({ formCycle: RequestLifeCycle.Loading, orderByMenuAnchorEl: null, dialog: null });

        api.getKnowledgeTestAdminList(p)
            .then((result) => {
                this.setState({ list: result, formCycle: RequestLifeCycle.None, offset: offset });
            })
            .catch((error) => {
                this.setState({ list: null, lastError: error, formCycle: RequestLifeCycle.LoadFailed, offset: 0 });
            });
    }

    ///
    private buildOrderByMenu() {
        const { orderBy, orderByMenuAnchorEl } = this.state;
        return (
            <>
                <IconButtonOrderBy
                    color="inherit"
                    onClick={
                        (e) => {
                            this.setState({ orderByMenuAnchorEl: e.currentTarget });
                        }
                    }
                />
                <Menu
                    anchorEl={orderByMenuAnchorEl}
                    open={orderByMenuAnchorEl != null}
                    onClose={
                        () => {
                            this.setState({ orderByMenuAnchorEl: null });
                        }}
                >
                    <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.DifficultyLevel")} value={KnowledgeTestAdminListOrderBy.DifficultyLevel} currentSelection={orderBy} onClick={this.applyOrder} />
                    <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.CreationDate")} value={KnowledgeTestAdminListOrderBy.CreateDate} currentSelection={orderBy} onClick={this.applyOrder} />
                    <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.MostAnswered")} value={KnowledgeTestAdminListOrderBy.MostAnswered} currentSelection={orderBy} onClick={this.applyOrder} />
                    <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.MostCorrect")} value={KnowledgeTestAdminListOrderBy.MostCorrect} currentSelection={orderBy} onClick={this.applyOrder} />
                    <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.MostWrong")} value={KnowledgeTestAdminListOrderBy.MostWrong} currentSelection={orderBy} onClick={this.applyOrder} />
                </Menu>
            </>
        );
    }

    ///
    private applyOrder = (orderBy: KnowledgeTestAdminListOrderBy) => {
        this.setState({ orderBy }, () => this.loadData(0));
    };

    ///
    private resetFilter(): KnowledgeTestAdminListFilter {

        this.isFiltered = false;

        return {
            topicId: this.selectedTopic == null ? null : this.selectedTopic.key,

            searchText: null,
            creationStartDate: null,
            creationEndDate: null,
            availableStartDate: null,
            availableEndDate: null,
            blockedOnly: false,
            showBlocked: false,

            attachTypes: null,
            authors: null,
            importances: null,
            levels: null
        };
    }

    ///
    private buildFilter(searchText: string, advFilters: AdvFilterResult[]): Partial<KnowledgeTestAdminListFilter> {

        const { filter } = this.state;

        this.isFiltered = true;

        const levels = [];
        if (advFilters.findIndex(x => x.keyword == CmdKTLevel1) > -1) levels.push(KnowledgeTestDifficultyLevel.Beginner);
        if (advFilters.findIndex(x => x.keyword == CmdKTLevel2) > -1) levels.push(KnowledgeTestDifficultyLevel.Intermediate);
        if (advFilters.findIndex(x => x.keyword == CmdKTLevel3) > -1) levels.push(KnowledgeTestDifficultyLevel.Advanced);

        const importances = [];
        if (advFilters.findIndex(x => x.keyword == CmdKTImportance1) > -1) importances.push(KnowledgeTestImportance.Low);
        if (advFilters.findIndex(x => x.keyword == CmdKTImportance2) > -1) importances.push(KnowledgeTestImportance.Normal);
        if (advFilters.findIndex(x => x.keyword == CmdKTImportance3) > -1) importances.push(KnowledgeTestImportance.High);

        const attachTypes = [];
        if (advFilters.findIndex(x => x.keyword == CmdWithVideo) > -1) attachTypes.push(FeedAttachType.Video);
        if (advFilters.findIndex(x => x.keyword == CmdWithImage) > -1) attachTypes.push(FeedAttachType.Image);

        const dtCreatedStartDate = advFilters.find(x => x.keyword == CmdCreateStartDate);
        const dtCreatedEndDate = advFilters.find(x => x.keyword == CmdCreateEndDate);
        const dtAvailableStartDate = advFilters.find(x => x.keyword == CmdAvailableStartDate);
        const dtAvailableEndDate = advFilters.find(x => x.keyword == CmdAvailableEndDate);

        return {
            searchText: searchText.length == 0 ? null : searchText,

            authors: advFilters.filter(x => x.keyword == CmdAuthor).map(v => v.value),
            levels: levels,
            importances: importances,
            attachTypes: attachTypes,

            creationStartDate: dtCreatedStartDate ? (dtCreatedStartDate.value as Date).putStartOfDay() : null,
            creationEndDate: dtCreatedEndDate ? (dtCreatedEndDate.value as Date).putEndOfDay() : null,
            availableStartDate: dtAvailableStartDate ? (dtAvailableStartDate.value as Date).putStartOfDay() : null,
            availableEndDate: dtAvailableEndDate ? (dtAvailableEndDate.value as Date).putEndOfDay() : null,
            blockedOnly: advFilters.findIndex(x => x.keyword == CmdKTBlocked) > -1,
            showBlocked: filter.showBlocked
        };
    }

    ///
    private updateAdvFilter = (searchText: string, advFilters: AdvFilterResult[]) => {
        const newFilter = (searchText.length == 0 && advFilters.length == 0)
            ? this.resetFilter()
            : this.buildFilter(searchText, advFilters);

        this.setState(
            {
                filter: { ...this.state.filter, ...newFilter },
                advFilters
            }, () => this.loadData(0)
        );
    };

    ///
    private handleShowBlocked = () => {
        this.setState(
            (state) => {
                state.filter.showBlocked = !state.filter.showBlocked;
                return state;
            }, () => this.loadData(0)
        );
    };

    ///
    private renderAdvFilter(): JSX.Element {
        const { advFilters, filter } = this.state;

        return (
            <MuiFilterAppBar position="static">
                <MuiFilterToolbar variant="dense" >
                    <MuiFilterLine>
                        <Grid container spacing={1} alignItems="center">
                            <Grid item xs>
                                <Button
                                    color="inherit"
                                    startIcon={<IconAdd />}
                                    onClick={() => this.handleEdit(null)}
                                >
                                    <span>{this.res("ButtonNewText")}</span>
                                </Button>
                            </Grid>
                            <Grid item>
                                <IconButtonBlocked
                                    title={this.props.t("Views.KnowledgeTest.AdminList.ButtonBlockTitle")}
                                    color={filter.showBlocked ? "warning" : "inherit"}
                                    onClick={this.handleShowBlocked}
                                />
                            </Grid>
                            <Grid item>
                                {this.buildOrderByMenu()}
                            </Grid>
                        </Grid>
                    </MuiFilterLine>

                    <MuiFilterAdvancedContainer disableMargins>
                        <AdvFilter
                            id="advfilter"
                            commands={this.commands}
                            innerRef={(ref) => this.advFilterRef = ref}
                            placeHolder={this.props.t("Common.Filter.Adv.InputPlaceholder")}
                            placeHolderFocus={this.props.t("Common.Filter.Adv.InputPlaceholderFocus")}
                            title={this.props.t("Common.Filter.Adv.InputTitleEnterToFilter")}
                            selectedCommands={advFilters}
                            onUpdateSelection={this.updateAdvFilter} />
                    </MuiFilterAdvancedContainer>
                </MuiFilterToolbar>
            </MuiFilterAppBar>
        );
    }

    ///
    private renderToolbar() {
        return (
            <AppBar position="sticky" color="default" className={GlobalClassKeys.stickyToolbar}>
                <Toolbar>

                    <Grid container alignItems="center">
                        <Grid item>
                            <ButtonBack
                                text={this.props.t("Common.Buttons.BackText")}
                                onClick={
                                    () => {
                                        this.props.history.goBack();
                                    }
                                }
                            />
                        </Grid>
                        {
                            <Grid item xs className={GlobalClassKeys.textCenter}>
                                <Typography variant="h6">
                                    {
                                        this.selectedTopic
                                            ? this.selectedTopic.label
                                            : this.res("Title")
                                    }
                                </Typography>
                            </Grid>
                        }
                    </Grid>

                </Toolbar>
            </AppBar >
        );
    }

    ///
    private handleEdit(testId: string) {
        this.setState({
            dialog: (
                <CreateTest
                    testId={testId}
                    initialTopic={
                        this.selectedTopic == null
                            ? null
                            : {
                                key: this.selectedTopic.key,
                                label: this.selectedTopic.label,
                                thumbnailUrl: this.selectedTopic.thumbnailUrl,
                                canDelete: false,
                                fixed: true
                            }
                    }
                    onClose={
                        (reload) => this.setState({ dialog: null }, () => {
                            reload && this.loadData(this.state.offset);
                        })
                    }
                />
            )
        });
    }

    ///
    private handleDelete(testId: string) {
        this.setState({
            dialog: <MuiConfirmation
                title={this.props.t("Common.Buttons.DeleteText")}
                message={this.res("ConfirmationDeleteMessage")}
                buttonNoText={this.props.t("Common.Buttons.CancelText")}
                buttonYesText={this.props.t("Common.Buttons.ConfirmText")}
                onClose={
                    (result) => {
                        if (result) {

                            this.setState({ dialog: null, formCycle: RequestLifeCycle.Posting });

                            api.deleteKnowledgeTest(testId)
                                .then((result) => {
                                    if (result) this.loadData(this.state.offset);
                                    else this.props.snackbar.showMessage(<AppMessage resource="OperationFailed" />, "error");
                                })
                                .catch((error) => {
                                    this.setState({ dialog: null, lastError: error, formCycle: RequestLifeCycle.PostFailed });
                                });
                        }
                        else {
                            this.setState({ dialog: null });
                        }
                    }
                }
            />
        });
    }

    ///
    private handleChangeActive = (testId: string, blocked: boolean) => {

        var title = this.res(blocked ? "ConfirmationBlockTitle" : "ConfirmationUnblockTitle");
        var message = this.res(blocked ? "ConfirmationBlockMessage" : "ConfirmationUnblockMessage");

        this.setState({
            dialog: <MuiConfirmation
                title={title}
                message={message}
                buttonNoText={this.props.t("Common.Buttons.CancelText")}
                buttonYesText={this.props.t("Common.Buttons.ConfirmText")}
                onClose={
                    (result) => {
                        if (result) {
                            api.changeKnowledgeTestActive(testId, blocked)
                                .then((result) => {
                                    if (result) this.setState({ dialog: null }, () => this.loadData(this.state.offset));
                                    else this.props.snackbar.showMessage(<AppMessage resource="OperationFailed" />, "error");
                                })
                                .catch(() => {
                                    this.setState({ dialog: null });
                                });
                        }
                        else {
                            this.setState({ dialog: null });
                        }
                    }
                }
            />
        });
    };

    ///
    private renderItems() {
        const { list } = this.state;

        if (list.total == 0 && !this.isFiltered)
            return Session.hasRole(SystemRoles.TestCreator) && !Session.hasRole(SystemRoles.TrainingManager)
                ? <MuiMessageBox variant="info" message={this.res("EmptyDataForTestCreator")} />
                : <MuiMessageBox variant="info" message={this.res("ResultText_zero")} />;

        if (list.total == 0 && this.isFiltered)
            return (
                <MuiMessageBox
                    variant="warning"
                    action={<ButtonResetFilter color="warning" onClick={() => this.advFilterRef.resetFilter()} />}
                    message={this.res("FilteredResultText_zero")}
                />
            );

        return (
            <MuiContainer margin="normal">

                <MuiContainer margin="normal">
                    <Grid container justifyContent="center" alignItems="center">
                        <Grid item xs>
                            <CountFilter
                                count={list.total}
                                filtered={this.isFiltered}
                                resource="Views.KnowledgeTest.AdminList.ResultText"
                                filteredResource="Views.KnowledgeTest.AdminList.FilteredResultText"
                                onResetFilter={() => this.advFilterRef.resetFilter()}
                            />
                        </Grid>
                        {
                            Session.hasRole(SystemRoles.TestCreator) && !Session.hasRole(SystemRoles.TrainingManager) &&
                            <Grid item>
                                <MuiWarning showIcon>{this.res("TestCreatorListInfo")}</MuiWarning>
                            </Grid>
                        }
                    </Grid>
                </MuiContainer>
                {
                    list.items.map((item, index) => (
                        <MuiContainer margin="dense" key={index}>
                            <KnowledgeTestAdminCard
                                item={item}
                                onEdit={() => this.handleEdit(item.testId)}
                                onDelete={() => this.handleDelete(item.testId)}
                                onChangeActive={this.handleChangeActive}
                                onNeedReload={() => this.loadData(this.state.offset)}
                            />
                        </MuiContainer>
                    ))
                }
                <MuiPagination
                    limit={DefaultListParameters.viewRecordsByPage}
                    offset={this.state.offset}
                    total={this.state.list.total}
                    onClick={(e, offset) => this.loadData(offset)}
                />
            </MuiContainer>
        );
    }

    ///
    private renderList() {
        const { lastError, formCycle } = this.state;

        if (lastError)
            return <RequestErrorReport error={lastError} />;

        return (
            <>
                {this.state.dialog}

                <RequestErrorDialog
                    open={formCycle == RequestLifeCycle.PostFailed}
                    error={lastError}
                    onClose={() => this.setState({ lastError: null, formCycle: RequestLifeCycle.None })}
                />

                <RequestIndicator
                    open={formCycle == RequestLifeCycle.Posting}
                    type="post"
                />

                <MuiContainer margin="normal">
                    {this.renderAdvFilter()}
                </MuiContainer>

                {
                    formCycle == RequestLifeCycle.Loading
                        ? <LoadingIndicator />
                        : this.renderItems()
                }
            </>
        );
    }

    ///
    public componentDidMount() {
        this.updateAdvFilter("", this.state.advFilters);
    }

    ///
    public render() {
        return (
            <div className={this.props.classes.timelineContainer}>
                {this.renderToolbar()}
                {this.renderList()}
            </div>
        );
    }
}

export default withRouter(withSnackbar(withTranslation()(withStyles(TimelineStyleClasses)(KnowledgeTestAdminList))));